import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Label,
  Tooltip,
} from "recharts";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsBugDashboard
} from "../../store/slice/bugSlice.js";
import GaugeComponent from "react-gauge-component";

const DashboardGraph = ({ dashboardDataByprojId, guid }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedProject } = useSelector((state) => {
    return state.bugDetails;
  });
  const { selectedClient } = useSelector((state) => {
    return state.clientDetails;
  });
  const bugSeverityData = dashboardDataByprojId?.bugSeverityAnalysis;
  const wcagWiseFailureData =
    dashboardDataByprojId?.wcagWiseFailureData?.filter(
      (item) => item.name !== "Total"
    );
  let projectHealth = dashboardDataByprojId.projectHealthpercentage;

  const CustomizedLabel = ({ totalValue }) => (
    <text
      x={200}
      y={170}
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize={14}
      fill="#1A1A1A"
    >
      <tspan fontSize={14} x={200} dy="0">{`Total Bugs:`}</tspan>
      <tspan fontSize={14} fontWeight={700} x={200} dy="1.2em">
        {totalValue}
      </tspan>
    </text>
  );

  const COLORS = ["#B73F21", "#F9E576", "#FF976A", "#5FB531"];

  const totalValue = bugSeverityData?.reduce(
    (acc, entry) => acc + entry.value,
    0
  );

  const handleClickWcagFailure = (entry) => {
    if (!guid) {
      dispatch(setIsBugDashboard(false));
      const state = {
        clientName: selectedClient?.label,
        projectName: selectedProject?.name,
        guid: selectedProject?.guid,
      };
      navigate(
        `./client/${selectedClient?.value}/project/${selectedProject?.id}`,
        {
          state: {
            ...state,
            paramName: entry.name,
          },
        }
      );
    } else {
      console.log("not allowed");
    }
  };

  const handleBugSeverityAnalysis = (entry) => {
    if (!guid) {
      dispatch(setIsBugDashboard(false));
      const state = {
        clientName: selectedClient?.label,
        projectName: selectedProject?.name,
        guid: selectedProject?.guid,
      };
      navigate(
        `./client/${selectedClient?.value}/project/${selectedProject?.id}`,
        {
          state: {
            ...state,
            paramName: entry.severity,
          },
        }
      );
    } else {
      console.log("not allowed");
    }
  };

  return (
    <div className="dashboard-graph">
      <div className="line-graph">
        <div className="graph-header">
          <h6>Project Health</h6>
        </div>

        <div className="graph">
          <GaugeComponent
            marginInPercent={0.05}
            style={{ width: "400px" }}
            type="semicircle"
            className="gauge-graph"
            arc={{
              width: 0.3,
              cornerRadius: 2,
              padding: 0.01,
              subArcs: [
                {
                  limit: 30,
                  color: "#B73F21",
                  showTick: false,
                  tooltip: {
                    text: "Worst",
                  },
                },
                {
                  limit: 60,
                  color: "#F9E576",
                  showTick: false,
                  tooltip: {
                    text: "Bad",
                  },
                },
                {
                  limit: 99,
                  color: "#FF976A",
                  showTick: false,
                  tooltip: {
                    text: "Good",
                  },
                },
                {
                  limit: 100,
                  color: "#5FB531",
                  showTick: false,
                  tooltip: {
                    text: "Excellent",
                  },
                },
              ],
            }}
            pointer={{
              color: "black",
              length: 0.8,
              width: 15,
            }}
            labels={{
              tickLabels: {
                type: "outer",
                ticks: [
                ],
              },
            }}
            value={parseInt(projectHealth)}
          />
        </div>
      </div>

      <div className="line-graph">
        <div className="graph-header">
          <h6>Issue Resolution Status Overview</h6>
        </div>

        <div className="graph">
          <PieChart width={400} height={400} margin={{ top: 25 }}>
            <Pie
              data={wcagWiseFailureData}
              cx={200}
              cy={150}
              innerRadius={50}
              outerRadius={110}
              paddingAngle={1}
              dataKey="value"
              label={(entry) => `${entry.name}: ${entry.value}`}
            >
              {wcagWiseFailureData?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                  onClick={() => handleClickWcagFailure(entry)}
                />
              ))}

              <Label
                content={<CustomizedLabel totalValue={totalValue} />}
                position="center"
                fill="#1A1A1A"
              />
            </Pie>

            <Tooltip />
          </PieChart>
        </div>
      </div>

      <div className="line-graph">
        <div className="graph-header">
          <h6>Bug Severity Analysis</h6>
        </div>

        <div className="graph">
          <PieChart width={420} height={400} margin={{ top: 25 }}>
            <Pie
              data={bugSeverityData}
              cx={200}
              cy={150}
              outerRadius={110}
              paddingAngle={1}
              dataKey="percent"
              label={(entry) =>
                `${entry.severity}: ${entry.percent}%`
              }
            >
              {bugSeverityData?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                  onClick={() => handleBugSeverityAnalysis(entry)}
                />
              ))}
            </Pie>
          </PieChart>
        </div>
      </div>
    </div>
  );
};

export default DashboardGraph;
